<ng-container *ngIf="vm.user && vm.shouldBeVisible()">
	<div class="c-header" [ngClass]="{'c-header--iizi': vm.hasIiziBusinessWallet && !vm.hasSiffiHeroBanner && (vm.activePath === '/'), 'c-header--siffi': vm.hasSiffiHeroBanner && (vm.activePath === '/'), 'c-header--hero': !vm.noHeroBanner && !vm.hasIiziBusinessWallet && !vm.hasSiffiHeroBanner && (vm.activePath === '/'), 'c-header--offset': vm.isProfileHeaderVisible}">
		<div class="o-container">
			<div *ngIf="vm.hasIiziBusinessWallet" class="c-header__iizi-logo u-hidden@up-to-lg"></div>
			<div class="o-grid">
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.user?.origin == 'minudoc.ee' && !vm.previsitLocation">
					<a id="headerLogoMinudoc" href="javascript:void(0);" class="c-header__logo c-logo"
					   [ngClass]="{'c-logo--en': vm.user.deviceLanguage === 'en_GB',
						 								 'c-logo--et': vm.user.deviceLanguage === 'et_EE',
						 								 'c-logo--ru': vm.user.deviceLanguage === 'ru_RU',
						 								 'c-logo--fi': vm.user.deviceLanguage === 'fi_FI'}"
					   (click)="vm.reload($event)"></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.user?.origin == 'siffi.com' && !vm.previsitLocation">
					<a id="headerLogoSiffi" href="javascript:void(0);" class="c-header__logo c-logo c-logo--siffi-green c-logo--siffi@up-to-md" (click)="vm.reload($event)"></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v" *ngIf="vm.previsitLocation">
					<a id="headerLogoPrevisit" href="javascript:void(0);" class="c-header__logo c-logo c-logo--previsit c-logo--previsit@up-to-md" (click)="vm.reloadToPrevisit($event)"></a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right o-grid__cell--center-v u-hidden@md-and-up" *ngIf="vm.isBackBtnVisible">
					<a id="headerBackButton" href="javascript:void(0);" (click)="vm.goBack($event)">{{ 'Steps.Button.Back' | translate }}</a>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-hidden@md-and-up" *ngIf="vm.user?.sessionsLeft && vm.isSearchable">
					<p class="c-info" id="sessionsLeftMobile">{{vm.user?.sessionsLeft}} {{ 'Services.Other.Sessions_Left' | translate }}</p>
				</div>
			</div>
		</div>
		<div *ngIf="vm.isSearchable && vm.hasSiffiHeroBanner">
            <div class="o-container">
                <div class="o-grid o-grid--wrap o-grid--reverse-v@up-to-md">
                    <div class="o-grid__cell o-grid__cell--w-100 c-cell">
                        <div class="c-content">
                            <my-training></my-training>
                        </div>
                    </div>
                </div>
            </div>
			<div class="o-container">
				<div class="o-grid o-grid--wrap o-grid--reverse-v@up-to-md">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up c-cell">
						<div class="c-content">
							<div class="c-content">
								<p class="c-header__heading">{{ 'Siffi.Services_Intro_1' | translate }}</p>
							</div>
							<div class="c-content">
								<p class="c-header__subheading">{{ 'Siffi.Services_Intro_2' | translate }}</p><br/>
								<p class="c-header__subheading">{{ 'Siffi.Services_Intro_3' | translate }}</p><br/>
								<p class="c-header__subheading" *ngIf="vm.weekendStartTimeInHours && vm.weekendEndTimeInHours">
									{{ ('Siffi.Services_Intro_4_Weekends' | translate).replace("%s", vm.startTimeInHours).replace("%e", vm.endTimeInHours).replace("%ws", vm.weekendStartTimeInHours).replace("%we", vm.weekendEndTimeInHours) }} {{ vm.isOutOfHoursMode ? ('Siffi.Services_Intro_5' | translate ) : ''}}
								</p>
								<p class="c-header__subheading" *ngIf="!vm.weekendStartTimeInHours && !vm.weekendEndTimeInHours">
									{{ ('Siffi.Services_Intro_4' | translate).replace("%s", vm.startTimeInHours).replace("%e", vm.endTimeInHours) }} {{ vm.isOutOfHoursMode ? ('Siffi.Services_Intro_5' | translate ) : ''}}
								</p>
	
								<div class="o-grid o-grid--center-v o-grid--center-h@up-to-md" *ngIf="vm.appLogoLang" style="margin-top: 20px;">
									<div style="padding-left:0px !important;" class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
										<a href="{{vm.iosLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/app-store-en.png" alt="App Store">
										</a>
									</div>
									<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim">
										<a href="{{vm.androidLink}}" target="_blank" rel="noreferrer noopener" class="c-header__btn"> <img src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/header/google-play-en.png" alt="Google Play">
										</a>
									</div>
								</div>
	
							</div>
							<div class="c-content" *ngIf="!vm.isOutOfHoursMode">
								<div class="o-grid">
									<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up o-grid__cell--left u-no-p">
										<a id="btn-hero-banner" (click)="vm.checkMentalHealthService()" class="c-button c-button--md c-button--s2 c-button--fit">{{ 'Siffi.Services_Intro_Proceed' | translate }}</a>
										<div id="btn-hero-banner-loader" class="c-button c-button--md c-button--s2 c-button--fit" style="display:none;padding-top:11px;padding-bottom:4px;">
											<div class="c-loader-rotate"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-50@md-and-up c-cell">
						<div class="c-header__picture"></div>
					</div>
				</div>
			</div>
		</div>
		<div class="c-header__content" *ngIf="vm.isSearchable && !vm.hasSiffiHeroBanner">
			<div class="o-container">
				<div class="o-grid o-grid--column">
					<div class="o-grid__cell o-grid__cell--w-fit">
						<h1 id="headerMainTitle" class="c-header__title">{{ 'Services.Title.Main' | translate }}</h1>
						<p class="c-header__subtitle">{{ 'Services.Title.Sub' | translate }} <a href="javascript:void(0)" id="toggleHowItWorksDrawerLink" (click)="vm.toggleDrawer($event)">{{ 'How_It_Works.Title' | translate }}</a></p>
					</div>
					<div *ngIf="vm.user?.origin == 'siffi.com'" class="o-grid__cell o-grid__cell--w-fit">
						<div class="o-grid o-grid--center-h o-grid--center-v">
								<div class="category-tabs u-no-mb">
									<a id="selectTab{{$index}}" name="selectTab{{$index}}" (click)="vm.handleTabClick($index)" class="category-tabs__link category-tabs__link--sm"
									   [ngClass]="{'category-tabs__link--active': vm.selectedTab === $index}" *ngFor="let tab of vm.tabs ; let $index=index" [(ngModel)]="vm.search.category">
										{{ tab.label | translate }}
									</a>
								</div>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-fit">
						<div class="o-grid">
							<div class="o-grid__cell--w-100 u-no-p">
								<div class="c-card c-header__card">
									<div class="c-content u-no-p@up-to-md">
										<form class="c-form">
											<div class="o-grid o-grid--wrap">
												<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p c-header__cell@md-and-up">
													<div class="o-grid o-grid--fit">
														<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--center-v o-grid__cell--slim c-header__cell u-hidden@md-and-up">
															<button type="button" class="c-button c-button--icon c-button--tp" (click)="vm.isFilterOpen=!vm.isFilterOpen">
																<i class="o-icon o-icon--filter c-text c-text--main u-no-mr" aria-hidden="true"></i>
																<span class="c-badge c-badge--xs c-badge--s1" style="position:absolute;margin-top:-7px;margin-left:12px" *ngIf="vm.search?.category || vm.search?.lang"></span>
																<span class="u-sr-only">{{ vm.isFilterOpen ? ('Services.Filter.Close' | translate) : ('Services.Filter.Open' | translate) }}</span>
															</button>
														</div>
														<div class="o-grid__cell c-header__cell u-no-p">
															<div class="c-form__group c-form__group--icon u-no-m" *ngIf="vm.search">
																<label for="term" class="c-form__label u-sr-only">{{ 'Services.Other.Search_Placeholder' | translate }}</label>
																<i class="o-icon o-icon--search c-form__icon" aria-hidden="true"></i>
																<input type="text" id="term" name="term" class="c-form__input c-form__input--no-border c-header__input" placeholder="{{ 'Services.Other.Search_Placeholder' | translate }}" spellcheck="false" [(ngModel)]="vm.search.term" (ngModelChange)="onSearchChange($event)">
															</div>
														</div>
													</div>
												</div>
												<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-75@md-and-up u-no-p c-header__cell@md-and-up c-header__filter" [ngClass]="{'c-header__filter--open': vm.isFilterOpen}">
													<div class="o-grid o-grid--fit o-grid--wrap@up-to-md">
														<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell@md-and-up" [ngClass]="{'o-grid__cell--w-25@md-and-up': vm.isCategoryPsychology, 'o-grid__cell--w-33@md-and-up': !vm.isCategoryPsychology}">
															<div *ngIf="vm.isCategorySelectionRequested" class="c-form__group u-no-m">
																<label for="category" class="c-form__label u-sr-only">{{ 'Services.Filter.Category' | translate }}</label>
																<mat-select [(value)]="vm.search.category" (closed)="vm.triggerSearch()" class="mat-select" id="category" placeholder="{{ 'Services.Filter.Category' | translate }}" data-md-container-class="mat-select-menu1">
																	<mat-option *ngFor="let category of vm.categories" [value]="category.furtherSubcategory || category.subcategory">{{ category.translation }}</mat-option>
																</mat-select>
															</div>
															<div *ngIf="!vm.isCategorySelectionRequested" style="display: flex; align-items: center; padding: 0 16px 0 0; width: 100%; height: 100%">
																<input type="text" id="selectedCat" name="selectedCat" disabled 
																	style="padding-left:5px;color:var(--mat-select-placeholder-text-color);"
																	class="u-hidden@md-and-up c-form__input c-form__input--no-border c-header__input" 
																	value="{{vm.getCategoryTranslation()}}">
																<input type="text" id="selectedCat" name="selectedCat" disabled 
																	style="padding-left:16px;color:var(--mat-select-placeholder-text-color);"
																	class="u-hidden@up-to-md c-form__input c-form__input--no-border c-header__input" 
																	value="{{vm.getCategoryTranslation()}}">
																<a (click)="vm.requestCategorySelection($event)"
																   style="font-weight: bold; white-space: nowrap; margin-left: 16px;"
																   href="javascript:void(0)">
																	<i class="o-icon o-icon--edit u-no-mr" aria-hidden="true"></i>
																</a>
																<a id="openTagSelectionModalButton"
																   (click)="vm.openTagSelectionDialog($event)"
																   style="font-weight: bold; margin-left: 16px"
																   class="u-hidden@up-to-md"
																   href="javascript:void(0)">
																	{{ 'Services.Filter.Filter_By_Condition' | translate }}
																</a>
																<a id="openTagSelectionModalIcon"
																   (click)="vm.openTagSelectionDialog($event)"
																   style="font-weight: bold; margin-left: 16px"
																   class="u-hidden@md-and-up"
																   href="javascript:void(0)">
																	<i class="o-icon o-icon--filter u-no-mr" aria-hidden="true"></i>
																</a>
															</div>
														</div>
														<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-25@md-and-up u-no-p c-header__cell@md-and-up" *ngIf="vm.isCategoryPsychology">
															<div class="c-form__group u-no-m">
																<label for="therapies" class="c-form__label u-sr-only">{{ 'Services.Filter.Therapies' | translate }}</label>
																<mat-select [(value)]="vm.search.therapies" (closed)="vm.triggerSearch()" class="mat-select" id="therapies" placeholder="{{ 'Services.Filter.Therapies' | translate }}" multiple data-md-container-class="mat-select-menu2">
																	<mat-option *ngFor="let therapy of vm.availableTherapies" [value]="therapy.therapy.name">{{ therapy.translation }}</mat-option>
																	<mat-select-trigger>{{ vm.getTherapiesText() }}</mat-select-trigger>
																</mat-select>
															</div>
														</div>
														<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell@md-and-up" [ngClass]="{'o-grid__cell--w-25@md-and-up': vm.isCategoryPsychology, 'o-grid__cell--w-33@md-and-up': !vm.isCategoryPsychology}">
															<div class="c-form__group u-no-m">
																<label for="lang" class="c-form__label u-sr-only">{{ 'Services.Filter.Languages' | translate }}</label>
																<mat-select [(value)]="vm.search.lang" (closed)="vm.triggerSearch()" class="mat-select" id="lang" placeholder="{{ 'Services.Filter.Languages' | translate }}" multiple data-md-container-class="mat-select-menu2">
																	<mat-option *ngFor="let lang of vm.searchLanguages" [value]="lang">{{ ('Services.Language.' + lang) | translate}}</mat-option>
																	<mat-select-trigger>{{ vm.getLanguagesText() }}</mat-select-trigger>
																</mat-select>
															</div>
														</div>
														<div class="o-grid__cell o-grid__cell--w-100 u-no-p c-header__cell@md-and-up" [ngClass]="{'o-grid__cell--w-25@md-and-up': vm.isCategoryPsychology, 'o-grid__cell--w-33@md-and-up': !vm.isCategoryPsychology}">
															<div class="c-form__group u-no-m">
																<label for="typeOfAppointment" class="c-form__label u-sr-only">{{ 'Subscription.Label.All_Sessions' | translate }}</label>
																<mat-select [(value)]="vm.search.typeOfAppointment" (closed)="vm.triggerSearch()" class="mat-select" id="typeOfAppointment" placeholder="{{ 'Subscription.Label.All_Sessions' | translate }}" data-md-container-class="mat-select-menu2">
																	<mat-option [value]="null">
																		{{ 'Subscription.Label.All_Sessions' | translate }}
																	</mat-option>
																	<mat-option *ngFor="let type of vm.typeOfAppointments" [value]="type">
																		{{ ('Subscription.Label.' + type) | translate }}
																	</mat-option>
																</mat-select>
															</div>
														</div>
													</div>
												</div>
											</div>
											<div *ngIf="vm.isTagFilterVisible() && vm.selectedTags?.length > 0" class="o-grid o-grid--wrap">
												<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
													<div class="c-tags__wrapper u-ost-md u-no-pt" data-tags-wrapper>
														<div *ngFor="let tag of vm.selectedTags" class="c-tag" style="display: table-cell; height: auto; cursor: pointer">
															<span>{{tag.translation}}</span>
															<i (click)="vm.clearSelectedTag(tag)" class="o-icon o-icon--x" style="margin: 4px 0 0 4px" aria-hidden="true"></i>
														</div>
														<div style="padding: 8px;">
															<a href="javascript:void(0)" (click)="vm.clearAllSelectedTags($event)">
																{{ 'Services.Filter.Clear_All' | translate }}
															</a>
														</div>
													</div>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="o-container u-hidden@up-to-md" *ngIf="vm.user?.businessUser">
			<div class="o-grid u-ost-xxl" *ngIf="vm.isProfileHeaderVisible">
				<div class="o-grid__cell o-grid__cell--w-100 u-no-p">
					<card-profile></card-profile>
				</div>
			</div>
			<div class="o-grid o-grid--right" [ngClass]="{'u-ost-xl': !vm.isProfileHeaderVisible}" *ngIf="vm.isShowTabs()">
				<div class="o-grid__cell o-grid__cell--w-fixed">
					<item-booking-status-switch></item-booking-status-switch>
				</div>
			</div>
			<div class="o-grid">
				<div class="o-grid__cell" *ngIf="vm.isShowTabs()">
					<div class="c-header__tabs" style="margin-left: -10px;">
						<ng-container *ngFor="let item of vm.menu?.items | jsonFilter:{isInTabs: true} ; let $index=index">
							<a id="tabsMenuItem{{$index}}" [attr.data-testid]="item.testId ? 'tabs-' + item.testId : null" routerLink="{{ item.href || item.children ? (item.href || item.children[0].href) : '' }}" class="c-tabs__link" [ngClass]="{ 'c-tabs__link--active': item.href && vm.activePath == item.href || item.children?.length && item.children.indexOf(vm.activePath) !== -1 || (item.href?.length > 1 && vm.activePath?.indexOf(item.href) === 0), 'c-tabs__link--w-badge': (item.showUnreadMessages &&  vm.unreadChatCount > 0) || (item.showUnconfirmedBookings && vm.unconfirmedBookingsCount > 0) || (item.href === '/bookings/instant' && vm.instantBookingsCount > 0) }" *ngIf="vm.isVisibleForUser(item) && (item.href!=='/bookings/instant' || vm.isInstantBookingAllowed)">
								<i class="o-icon o-icon--{{ item.icon}}" aria-hidden="true" *ngIf="item.href === '/schedule'"></i> {{ item.label }}
								<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.showUnreadMessages && vm.unreadChatCount > 0">{{vm.unreadChatCount}}</span>
								<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.showUnconfirmedBookings && vm.unconfirmedBookingsCount > 0">{{vm.unconfirmedBookingsCount}}</span>
								<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.href === '/bookings/instant' && vm.instantBookingsCount > 0">{{vm.instantBookingsCount}}</span>
							</a>
						</ng-container>
					</div>
				</div>
			</div>
		</div>
		<nav class="c-nav c-nav--tab-bar">
			<div class="o-container" *ngIf="vm.shouldBeVisible()">
				<div class="c-nav__menu">
					<ul class="c-nav__list">
						<li class="c-nav__item u-hidden@up-to-md" *ngIf="vm.user?.sessionsLeft && vm.isSearchable">
							<p class="c-info" style="cursor: default;" id="sessionsLeftDesktop">{{vm.user?.sessionsLeft}} {{ 'Services.Other.Sessions_Left' | translate }}</p>
						</li>
						<!-- Menu -->
						<ng-container *ngFor="let item of vm.menu?.items ; let $index=index">
							<li class="c-nav__item" [ngClass]="{ 'u-hidden@up-to-md': item.isHiddenInMobile, 'u-hidden@md-and-up': item.isHiddenInDesktop }" *ngIf="vm.isVisibleForUser(item)">
								<a *ngIf="item.onClick" id="menuItem{{$index}}" [attr.data-testid]="item.testId ? 'header-' + item.testId : null" style="cursor:pointer;" class="c-nav__link" [ngClass]="{ 'c-nav__link--active': (item.href && vm.activePath == item.href || item.children?.length && item.children.indexOf(vm.activePath) !== -1 || (item.href?.length > 1 && vm.activePath?.indexOf(item.href) === 0))}" (click)="item.href==='#' && item.onClick && item.onClick($event)">
									<i class="o-icon o-icon--{{ item.icon }} u-hidden@md-and-up" *ngIf="item.icon" aria-hidden="true"></i>
									<span id="menuItemValue{{$index}}" class="c-nav__label c-text">{{ item.label }}</span>
									<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.showUnreadMessages && vm.unreadChatCount > 0">{{vm.unreadChatCount}}</span>
									<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.showUnconfirmedBookings && (vm.unconfirmedBookingsCount > 0 || vm.instantBookingsCount > 0)">{{(vm.unconfirmedBookingsCount || 0) + (vm.instantBookingsCount || 0)}}</span>
								</a>
								<a *ngIf="!item.onClick" id="menuItem{{$index}}" [attr.data-testid]="item.testId ? 'header-' + item.testId : null" routerLink="{{ item.href }}" class="c-nav__link" [ngClass]="{ 'c-nav__link--active': (item.href && vm.activePath == item.href || item.children?.length && item.children.indexOf(vm.activePath) !== -1 || (item.href?.length > 1 && vm.activePath?.indexOf(item.href) === 0))}">
									<i class="o-icon o-icon--{{ item.icon }} u-hidden@md-and-up" *ngIf="item.icon" aria-hidden="true"></i>
									<span id="menuItemValue{{$index}}" class="c-nav__label c-text">{{ item.label }}</span>
									<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.showUnreadMessages && vm.unreadChatCount > 0">{{vm.unreadChatCount}}</span>
									<span class="c-badge c-badge--s2 c-nav__badge" *ngIf="item.showUnconfirmedBookings && (vm.unconfirmedBookingsCount > 0 || vm.instantBookingsCount > 0)">{{(vm.unconfirmedBookingsCount || 0) + (vm.instantBookingsCount || 0)}}</span>
								</a>
							</li>
						</ng-container>
						<li class="c-nav__item c-nav__item--divider u-hidden@up-to-md" *ngIf="!vm.user?.businessUser"><span style="visibility:hidden;">Separator</span></li>
						<!-- Dropdown menu -->
						<li class="c-nav__item c-nav__dd u-hidden@up-to-md">
							<a id="toggleDropDownNavMenu" data-testid="header-profile-dropdown" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow">
								<i class="o-icon o-icon--user u-hidden@md-and-up" aria-hidden="true"></i>
								<div style="background-image: url('{{ vm.getProfileImg(vm.user) }}')" class="c-nav__thumb u-hidden@up-to-md" aria-hidden="true"></div>
								<span *ngIf="!vm.user?.adminAssistant" id="userNameLabel" style="padding-bottom: 2px;" class="c-nav__label c-nav__label--w-fixed c-text c-text--cut">{{ vm.user?.firstname }} {{ vm.user?.lastname }}</span>
								<span *ngIf="vm.user?.adminAssistant" id="userNameLabel" style="padding-bottom: 2px;" class="c-nav__label c-nav__label--w-fixed c-text c-text--cut">{{ vm.user?.adminAssistant.firstname }} {{ vm.user?.adminAssistant.lastname }}</span>
							</a>
							<div class="c-nav__dd-menu">
								<a href="javascript:void(0);" id="dropDownMenuRoot" class="c-nav__logo c-logo" [ngClass]="{'c-logo--en': vm.user.deviceLanguage === 'en_GB', 'c-logo--et': vm.user.deviceLanguage === 'et_EE', 'c-logo--ru': vm.user.deviceLanguage === 'ru_RU', 'c-logo--fi': vm.user.deviceLanguage === 'fi_FI'}"></a>
								<ul class="c-nav__dd-list">
									<ng-container *ngFor="let item of vm.menu?.dropdownItems ; let $index=index">
										<li class="c-nav__dd-item" [ngClass]="{'u-hidden@md-and-up': item.isHiddenInDesktop}" *ngIf="vm.isVisibleForUser(item)">
											<a *ngIf="!item.onClick" id="dropDownMenuItem{{$index}}" [attr.data-testid]="item.testId ? 'header-' + item.testId : null" routerLink="{{ item.href }}" class="c-nav__dd-link">
												<i class="o-icon o-icon--{{ item.icon }} c-nav__dd-icon" aria-hidden="true"></i>
												<span id="dropDownMenuItemValue{{$index}}" class="c-text">{{ item.label }}</span>
											</a>
											<a *ngIf="item.onClick" id="dropDownMenuItem{{$index}}" [attr.data-testid]="item.testId ? 'header-' + item.testId : null" style="cursor:pointer;" class="c-nav__dd-link" (click)="item.href==='#' && item.onClick && item.onClick($event, vm)">
												<i class="o-icon o-icon--{{ item.icon }} c-nav__dd-icon" aria-hidden="true"></i>
												<span id="dropDownMenuItemValue{{$index}}" class="c-text">{{ item.label }}</span>
											</a>
										</li>
									</ng-container>
								</ul>
							</div>
						</li>
						<!-- Language menu -->
						<li class="c-nav__item" *ngIf="vm.user?.origin == 'siffi.com'">
							<siffi-language-picker
								[currentLocale]="vm.locale"
								[compact]="true"
								[disabled]="vm.langDisabled"
								(localeSelected)="vm.setLocale($event)">
							</siffi-language-picker>
						</li>
						<li class="c-nav__item c-nav__dd" [ngClass]="{ 'c-nav__dd--open': vm.langOpen }" *ngIf="vm.user?.origin != 'siffi.com'">
							<a id="selectedLangMenu" class="c-nav__link c-nav__dd-toggle c-nav__dd-toggle--arrow" (click)="vm.toggleLangMenu()">
								<i class="c-flag c-flag--{{ vm.getLocaleOption(vm.locale).icon }} c-nav__thumb" aria-hidden="true"></i>
								<span id="selectedLangValue" class="c-nav__label c-text c-text--uppercase">{{ vm.getLocaleOption(vm.locale).shortLabel }}</span>
							</a>
							<div class="c-nav__dd-menu">
								<ul class="c-nav__dd-list">
									<ng-container *ngFor="let language of vm.locales ; let $index=index">
										<li class="c-nav__dd-item" *ngIf="language.locale !== vm.locale">
											<a id="selectLang{{$index}}" href="javascript:void(0)" class="c-nav__dd-link" (click)="vm.setLocale(language.locale)">
												<i class="c-flag c-flag--{{ language.icon }} c-nav__dd-icon c-nav__thumb" aria-hidden="true"></i>
												<span id="selectLangValue{{$index}}" class="c-text c-text--uppercase">{{ language.shortLabel }}</span>
											</a>
										</li>
									</ng-container>
								</ul>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</nav>
	</div>
	<div class="c-notice c-notice--s2 u-ost-md@up-to-md" *ngIf="vm.prescriptionRenewals?.length && vm.isSearchable && vm.isPharmacyPurchasingSupported">
		<div class="o-container">
			<div class="o-grid o-grid--center-v">
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-pr u-no-p@up-to-md">
					<p class="c-text c-text--s4" aria-hidden="true">
						<i class="o-icon o-icon--cart c-text c-text--lg"></i>
					</p>
				</div>
				<div class="o-grid__cell u-no-pr">
					<p class="c-text c-text--s4">{{ 'Booking.Prescription.Renewal_Notification' | translate }} <a href="javascript:void(0);" class="c-text c-text--bold c-text--s4 u-clickable" (click)="vm.goToPharmacy()">{{ 'Common.Click_Here' | translate }}</a></p>
				</div>
			</div>
		</div>
	</div>
</ng-container>
